import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { classNames, format } from '@dt/fe-utils'

interface IProps {
  selected?: boolean;
  amount: number;
  onChange: () => void;
}
const AppleSimpleItem: FC<IProps> = ({ selected, amount, onChange }) => {
  const [isShow, setIsShow] = useState(false)
  const handleChange = () => {
    onChange()
  }
  return (
    <div
      className={classNames('mall-external-pay-method-item', 'apple-pay-web', { selected })}
      onClick={handleChange}
    >
      <div className='card-left'>
        <i className='iconfont icon-pay'></i>
      </div>
      <div className='card-content'>
        <div className='title-top'>
          <i className='name iconfont icon-a-applepay'></i>
        </div>
        <div className='amount'>
          {selected && format.toPrice(amount)}
        </div>
      </div>
      <div className='amount-select'>
        <i className={classNames('iconfont', selected ? 'icon-checked' : 'no-select')} />
      </div>
    </div>
  )
}

export default observer(AppleSimpleItem)
